import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import 'rxjs/Rx';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Overlay, overlayConfigFactory } from 'angular2-modal';

import { UserService } from '../../../../_services/userservice/user.service';
import { utilityService } from '../../../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../../../sharedcomponents/_common/constants/app.constants';
import { User } from '../../../../models/user/user';
import { AlertService } from '../../../../sharedcomponents/commonservice/alert.service';
export class CustomModalContext extends BSModalContext {
  public infoMessage: string;
}

@Component({
  moduleId: module.id,
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css'],
  providers: [UserService, AppSettings, AlertService]
})
export class UserInfoComponent implements ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  model: any = {};
  loading = false;
  public wrongAnswer: boolean;
  messageText: string;

  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    public modal: Modal,
    private alertService: AlertService,
    private userService: UserService,
    private utilserv: utilityService
  ) {
    this.wrongAnswer = true;
    this.context = dialog.context;

    this.messageText = this.context.infoMessage;
  }
  closePopup() {
    this.dialog.close();
    this.router.navigate(['/login']);
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/RegistrationPopup/user-info/user-info.component.ts